<template>
    <div class="submain">
        <div class="block_22">
            <div class="view_9">
                <img
                        class="buttonBg_2"
                        src="../images/img_32389_0_306.png"
                />
                <span class="text_8" >一起学习</span>
                <span class="txt_13" >一起成长</span>
            </div>
            <div class="tagWrap" @click="moreExciting">
                <span class="tagName" >更多精彩</span>
            </div>
        </div>
        <div class="view_11" v-if="list.length != 0">
            <div class="swiper-button-prev prev2" slot="button-prev"></div>
            <swiper class="swiper" ref="swiper" :options="specialCourseSwiperOption" style="width: 92%" >
                <swiper-slide v-for="(item, index) in list" :key="index">
                    <div class="block_23"  @click="enterDetails(item)">
                        <div class="bgWrap">
                            <img
                                alt=""
                                class="product"
                                :src="item.masterImg"
                                v-if="item.masterImg"
                            />
                            <img
                                v-else
                                class="product"
                                src="@/assets/noclass.png"
                            />
                        </div>
                        <div class="group_3">
                            <span class="info_14" >{{item.name1}}</span>
                            <div class="summaryWrap">
                                <span class="summary" :lines="3">{{item.description | htmlize}}</span>
                            </div>
                            <div class="moneyWrap">
                                <div class="outer">
                                    <div class="wrap">
                                        <img
                                                class="icon_12"
                                                src="../images/img_32389_0_420.png"
                                        />
                                        <img
                                                class="picture"
                                                src="../images/img_32389_0_421.png"
                                        />
                                        <img
                                                class="icon_13"
                                                src="../images/img_32389_0_422.png"
                                        />
                                    </div>
                                    <span class="num_2" >{{item.productSales}}</span>
                                </div>
                                <span class="money" v-if="item.mallPcPrice && item.mallPcPrice != 0.00">¥{{item.mallPcPrice}}</span>
                                <span class="money" v-else>免费</span>
                            </div>
                        </div>
                    </div>
                </swiper-slide>                
            </swiper>
            <div class="swiper-button-next next2" slot="button-next"></div>
        </div>
    </div>
</template>

<script>
    import {getProductRecommendList} from "@/servers/api"
    export default {
        name: "specialCourse",
        data() {
            return {
                specialCourseSwiperOption: { // 专题训练营
                    slidesPerView: 2,
                    spaceBetween: 30,
                    direction: 'horizontal',
                    navigation: {
                        nextEl: '.next2',
                        prevEl: '.prev2'
                    },
                    on: {
                        resize: () => {
                            this.$refs.swiper.$swiper.changeDirection(
                                window.innerWidth <= 960
                                    ? 'vertical'
                                    : 'horizontal'
                            )
                        }
                    }
                },
                list: []
            }
        },
        filters: {
            htmlize: function (value) {
                if (!value) return ''               
                var re1 = new RegExp("<.+?>","g");//匹配html标签的正则表达式，"g"是搜索匹配多个符合的内容
                var msg = value.replace(re1,'');//执行替换成空字符
                return msg;
            }
        },
        methods: {
            async getProductRecommendList() {
                const res = await getProductRecommendList();
                if (res.code == 0) {
                    this.list = res.data.specialProductList;
                }
            },
            moreExciting() {
                window.open('#/excellentCourse') 
                //  this.$router.push({
                //     path: '/excellentCourse',
                //     query: {}
                // });    
            },
            enterDetails(item) {
                window.open('#/course/detail?id=' + item.id) 
            }
        },
        created() {
            this.getProductRecommendList()
        }
    }
</script>

<style src="../index.css" scoped></style>

<style lang="less" scoped>
    .swiper-slide{overflow: hidden}
    .view_11 .swiper-button-next{
        color: white;
        right: 5px;
    }
    .view_11 .swiper-button-prev{
        color: white;
        left: 5px;
    }
    .group_3 {
        display: flex;
        align-items: flex-start;
        flex-direction: column;
        margin-top: 3px;
        height: 176px;
        padding: 0 30px;
    }
    .block_23 {
        cursor: pointer;
    }
    .block_23 .product {
        -webkit-transition: all 1s ease;
        -moz-transition: all 1s ease;
        -ms-transition: all 1s ease;
        -o-transition: all 1s ease;
        transition: all 1s ease;
    }
    // .block_23:hover .product {
    //     -webkit-transform: scale(1.1);
    //     -moz-transform: scale(1.1);
    //     -ms-transform: scale(1.1);
    //     -o-transform: scale(1.1);
    //     transform: scale(1.1);
    // }
    .info_14 {
        position: relative;
        opacity: 1;
        // max-width: 250px;
        width: 165px;
        height: 25px;
        overflow: hidden;
        text-overflow: ellipsis;
        line-height: 25px;
        white-space: nowrap;
        color: #333333;
        font-size: 18px;
        font-weight: 400;
    }

    .summaryWrap {
        display: flex;
        position: relative;
        align-items: center;
        flex-direction: row;
        margin-top: 23px;
        // width: 224px;
        height: 66px;
    }

    .summary {
        webkit-line-clamp: 3px;
        position: relative;
        opacity: 1;
        width: 165px;
        height: 66px;
        overflow: hidden;
        text-overflow: ellipsis;
        line-height: 22px;
        color: #999999;
        font-size: 14px;
        font-weight: 400;

        overflow : hidden;
        text-overflow: ellipsis;
        /* 将对象作为弹性伸缩盒子模型显示  */
        display: -webkit-box;
        /* 一个块元素显示的文本的行数 */
        -webkit-line-clamp: 3;
        /* 设置或检索伸缩盒对象的子元素的排列方式 */
        -webkit-box-orient: vertical;
    }

    .text_9 {
        position: absolute;
        bottom: 0;
        left: 42px;
        opacity: 1;
        line-height: 22px;
        white-space: nowrap;
        color: #999999;
        font-family: Helvetica;
        font-size: 14px;        
    }

    .moneyWrap {
        display: flex;
        position: relative;
        align-items: center;
        flex-direction: row;
        justify-content: space-between;
        margin-top: 43px;
        width: 165px;
        height: 19px;
    }

    .outer {
        display: flex;
        align-items: center;
        flex-direction: row;
        height: 19px;
        margin: 0;
    }
    .tagWrap {
        cursor: pointer;
        width:106px;
        height:30px;
        line-height: 30px;
        text-align: center;
        border-radius:2px;
        opacity:0.9;
        border:1px solid rgba(255,255,255,1);
        font-size:16px;
        color: #FFFFFF;
    }
</style>
